<template>
  <div>
    <v-file-input v-model="file" placeholder="Upload Train" label="File input" prepend-icon="mdi-paperclip" @change="onFileSelect($event)">
      <template v-slot:selection="{ text }">
        <v-chip small label color="primary">
          {{ text }}
        </v-chip>
      </template>
    </v-file-input>
    <div id="app" ref="spreadsheet"></div>
    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
  </div>
</template>


<script>
import axios from 'axios'
import jexcel from 'jexcel'
import 'jexcel/dist/jexcel.css'

var data = [
  // ['Jazz', 'Honda', '2019-02-12', '', true, '$ 2.000,00', '#777700'],
  // ['Civic', 'Honda', '2018-07-11', '', true, '$ 4.000,01', '#007777']
]
var changed = function(instance, cell, x, y, value) {
    var cellName = jexcel.getColumnNameFromId([x,y]);
    console.log(data)
    console.log('New change on cell ' + cellName + ' to: ' + value + '',x,y);
}
var options = {
  data: data,
  allowToolbar:true,
  onchange: changed,
  columns: [
    {title: 'Sl No.', name: 'stn_sr_no', type: 'number', sorting: true},
    {title: 'train_no', name: 'train_no', type: 'text', width:'70px'},
    {title: 'stn_name', name: 'stn_name', type: 'text', width:'150px'},
    {title: 'stn_type', name: 'stn_type', type: 'text'},
    {title: 'stn_code', name: 'stn_code', type: 'text', width:'70px',},
    {title: 'block_section', name: 'block_section', type: 'text', width:'100px'},
    {title: 'wtt_arr', name: 'wtt_arr', type: 'text', mask:'hh24:mi:ss', options:{ reverse: true }, width:'70px'},
    {title: 'wtt_day_arr', name: 'wtt_day_arr', type: 'numeric'},
    {title: 'wtt_dep', name: 'wtt_dep', type: 'text', mask:'hh24:mi:ss', options:{ reverse: true }, width:'70px'},
    {title: 'wtt_day_dep', name: 'wtt_day_dep', type: 'numeric'},
    {title: 'stop', name: 'stop', type: 'text'},
    {title: 'ptt_arr', name: 'ptt_arr', type: 'text', mask:'hh24:mi:ss', options:{ reverse: true }, width:'70px'},
    {title: 'ptt_day_arr', name: 'ptt_day_arr', type: 'numeric'},
    {title: 'ptt_dep', name: 'ptt_dep', type: 'text', mask:'hh24:mi:ss', options:{ reverse: true }, width:'70px'},
    {title: 'ptt_day_dep', name: 'ptt_day_dep', type: 'numeric'},
    {title: 'pf', name: 'pf', type: 'text'},
    {title: 'division', name: 'division', type: 'text'},
    {title: 'zone', name: 'zone', type: 'text'},
    {title: 'tr', name: 'tr', type: 'numeric'},
    {title: 'er', name: 'er', type: 'numeric'},
    {title: 'distance', name: 'distance', type: 'numeric', mask:'$ #.##,00', decimal:',' }
  ]
}

export default {
  name: 'trainsdtl',
  mounted: function () {
    this.getTrains()
    let spreadsheet = jexcel(this.$el, options)
    Object.assign(this, { spreadsheet })
  },
  data() {
    return {
        test: null,
        file: [],
      }
  },

  methods: {
    getTrains() {
      data = []
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/timetable/train/${this.$route.query.train_no}`)
        .then(response => {
          console.log(response);
          this.spreadsheet.setData(response.data)
        })
        .catch(e => {
          console.log(e)
        })
    },
    save() {
      // if (this.editedRowIDs.size == 0) {
      //   return
      // }
      // console.log(this.editedRows)
      // this.editedRowIDs.forEach( id => {
      //   this.editedRows.push(this.gridApi.getRowNode(id).data)
      //   console.log(this.editedRows)
      //   }
      // );
      var p = {
        edited_trains: this.spreadsheet.getJson()
      }
      console.log(this.spreadsheet.getJson())
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

      axios.post(`${process.env.VUE_APP_API_URL}/timetable/train_dtls`, p)
      .then(response => {
        // clear the set post update call
       // this.editedRowIDs.clear();
       // this.editedRows = []
          console.log(response)
        })
      .catch(e => {
        console.log(e)

      })
       // call the api to update data

    },
    onFileSelect($event) {
      console.log($event)
      console.log(this.file)
      if ($event) {
        let formData = new FormData();
        formData.append('file', this.file);
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        axios.post(`${process.env.VUE_APP_API_URL}/train/tr/traincsvupload`, formData)
          .then(response => {
            console.log(response)
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    changed(instance, cell, x, y, value) {

    console.log(instance, cell, x, y, value)

    }
  }

}
</script>
<style lang='scss'>

@import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap4";

</style>
